<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError == '400') {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.administration.printer.shared.errors.bad-request' | translate }}
		</mat-error>
	}
	@if (httpError == '404') {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.administration.printer.shared.errors.not-found' | translate }}
		</mat-error>
	}
	@if (httpError == '409') {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.administration.printer.shared.errors.duplicate' | translate }}
		</mat-error>
	}
	@if (httpError == '500') {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.administration.printer.shared.errors.internal-server-error' | translate }}
		</mat-error>
	}

	<h1 mat-dialog-title class="notification-title no-select">
		{{ 'mes.administration.printer.edit.header' | translate }}
	</h1>

	<mat-dialog-content>
		<div class="optional-form-fields">
			<mat-error *ngIf="controls['alias'].invalid && controls['alias'].touched">
				{{ 'mes.administration.printer.dialog.name.error.' + getFirstValidationErrorName('alias') | translate }}
			</mat-error>
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.printer.shared.name' | translate }}
				</mat-label>
				<input maxlength="255" matInput formControlName="alias" />
			</mat-form-field>

			@if (controls['description'].invalid && controls['description'].touched) {
				<mat-error>
					{{ 'mes.administration.printer.dialog.description.error.' + getFirstValidationErrorName('description') | translate }}
				</mat-error>
			}
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.printer.shared.description' | translate }}
				</mat-label>
				<input maxlength="255" matInput formControlName="description" />
			</mat-form-field>

			@if (controls['encoding'].invalid && controls['encoding'].touched) {
				<mat-error>
					{{ 'mes.administration.printer.dialog.encoding.error.' + getFirstValidationErrorName('encoding') | translate }}
				</mat-error>
			}
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.printer.shared.encoding' | translate }}
				</mat-label>
				<input #encodingInput type="text" maxlength="255" placeholder="{{ 'mes.administration.printer.dialog.encoding.placeholder' | translate }}" matInput formControlName="encoding" [matAutocomplete]="auto" />
				<button mat-icon-button matSuffix tabindex="-1" type="button" (click)="openAutocomplete()">
					<mat-icon>arrow_drop_down</mat-icon>
				</button>
				<mat-autocomplete #auto="matAutocomplete">
					@for (encoding of encodings; track encoding) {
						<mat-option [value]="encoding">
							{{ encoding }}
						</mat-option>
					}
				</mat-autocomplete>
			</mat-form-field>

			<mat-error *ngIf="controls['printerPath'].invalid && controls['printerPath'].touched">
				{{ 'mes.administration.printer.dialog.printer-path.error.' + getFirstValidationErrorName('printerPath') | translate }}
			</mat-error>
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.printer.shared.printer-path' | translate }}
				</mat-label>
				<input maxlength="255" matInput formControlName="printerPath" />
			</mat-form-field>

			<div class="tags-section">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.printer.shared.tags' | translate }}
				</mat-label>
				<div class="tags-input-row">
					<mat-form-field appearance="outline" class="dialog tags-input">
						<mat-label>
							{{ 'mes.administration.printer.dialog.tags.name-placeholder' | translate }}
						</mat-label>
						<input matInput maxlength="255" [(ngModel)]="newTagName" [ngModelOptions]="{ standalone: true }" />
					</mat-form-field>
					<mat-form-field appearance="outline" class="dialog tags-input">
						<mat-label>
							{{ 'mes.administration.printer.dialog.tags.value-placeholder' | translate }}
						</mat-label>
						<input matInput maxlength="255" [(ngModel)]="newTagValue" [ngModelOptions]="{ standalone: true }" (keyup.enter)="addTag()" />
					</mat-form-field>
					<button mat-stroked-button type="button" class="button-border-color" (click)="addTag()" [disabled]="!newTagName.trim() || !newTagValue.trim()">
						{{ 'mes.administration.printer.dialog.tags.add' | translate }}
					</button>
				</div>
				<mat-error *ngIf="tagError">{{ tagError | translate }}</mat-error>
				<mat-chip-set class="tags-chip-set" *ngIf="printer.tags.length">
					<mat-chip *ngFor="let tag of printer.tags" (removed)="removeTag(tag)">
						{{ tag.name }}={{ tag.value }}
						<button matChipRemove type="button">
							<mat-icon>cancel</mat-icon>
						</button>
					</mat-chip>
				</mat-chip-set>
			</div>
		</div>
	</mat-dialog-content>

	<div>
		<div mat-dialog-actions align="end">
			<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid">
				{{ 'mes.administration.printer.shared.savebtn' | translate }}
			</button>
			<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">
				{{ 'mes.administration.printer.shared.cancelbtn' | translate }}
			</button>
		</div>
	</div>
</form>
